import styled from '@emotion/styled';

import { Button, forMobile } from '@/design-system';

export const Shell = styled('div')(({ theme }) => ({
  minHeight: '100dvh',
  display: 'grid',
  gridTemplateRows: 'auto 1fr',
  backgroundColor: theme.colors.background.canvas,
  color: theme.colors.text.primary,
}));

export const Header = styled('header')(({ theme }) => ({
  padding: `${theme.spacing[24]}px ${theme.spacing[32]}px`,
  [forMobile]: {
    padding: theme.spacing[20],
  },
}));

export const Main = styled('main')(({ theme }) => ({
  width: '100%',
  maxWidth: 568,
  margin: '0 auto',
  padding: `0 ${theme.spacing[24]}px ${theme.spacing[80]}px`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignSelf: 'center',
  gap: theme.spacing[12],
  textAlign: 'center',
  boxSizing: 'border-box',
  [forMobile]: {
    padding: `0 ${theme.spacing[20]}px ${theme.spacing[56]}px`,
  },
}));

export const NoticeButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing[12],
  [forMobile]: {
    width: '100%',
  },
}));
